var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"Loading flex h-full w-full justify-center items-center"},[_c('div',{staticClass:"dot dot1"}),_vm._v(" "),_c('div',{staticClass:"dot dot2"}),_vm._v(" "),_c('div',{staticClass:"dot dot3"})])
}]

export { render, staticRenderFns }